import { createApi } from '@reduxjs/toolkit/query/react';
import { fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { IPage, IStore } from '../../modules/storefront/exports/Interfaces';
import StorefrontManager from '../../services/api/StorefrontManager';

export const storefrontApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'storefrontApiSlice',
  endpoints: (build) => ({
    getStore: build.query<IStore, unknown>({
      queryFn: () =>
        StorefrontManager.getStore().then((res) => {
          if (res.success) {
            return { data: res.response.data?.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      keepUnusedDataFor: 600,
    }),
    getPage: build.query<IPage, string>({
      queryFn: (page) =>
        StorefrontManager.getPage(page).then((res) => {
          if (res.success) {
            return { data: res.response.data?.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetStoreQuery, useGetPageQuery } = storefrontApiSlice;
